<template>
    <div class="aggregator">
        <div class="columns">
            <div class="column is-2">
                <label class="label">Search provider</label>
                <div class="field has-addons">
                    <div class="control">
                        <input type="text" class="input oc-input is-small" placeholder="Provider"
                            v-model="searchProvider">
                    </div>
                    <div class="control">
                        <button @click="searchProvider = '';" class="button is-danger is-small">
                            Clear
                        </button>
                    </div>
                </div>
                <item-list :activeItem="this.filter.provider" :selectItem="selectProvider" :items="providersByName" />
            </div>
            <div class="column is-2">
                <label class="label">Search category</label>
                <div class="field has-addons">
                    <div class="control">
                        <input type="text" class="input oc-input is-small" placeholder="Category"
                            v-model="searchCategory">
                    </div>
                    <div class="control">
                        <button @click="searchCategory = '';" class="button is-danger is-small">
                            Clear
                        </button>
                    </div>
                </div>
                <item-list :activeItem="this.filter.category" :selectItem="selectCategory" :items="categoriesByName" />
            </div>
            <div class="column">
                <label class="label">Search games</label>
                <div class="field has-addons">
                    <div class="control">
                        <input class="input is-small" @input="(event) => searchHandler(event)" :value="filter.search" type="text" placeholder="Find a game">
                    </div>
                    <div class="control">
                        <button class="button is-info is-small" @click="showGames();">
                            Search
                        </button>
                    </div>
                    <div class="control">
                        <button @click="filter.search = ''; showGames()" class="button is-danger is-small">
                            Clear
                        </button>
                    </div>
                </div>
            </div>
            <div class="column has-text-right is-1">
                <router-link :to="{ 'name': 'client-games-aggregator-settings' }" active-class="is-active" class="button is-outlined is-pulled-right" tag="a">Settings</router-link>
            </div>
            <div class="column is-1">
                <a class="button is-danger is-outlined is-pulled-right" @click="sync()">Sync</a>
            </div>
        </div>
        <game-list
            ref="gamelist"
            :provider="this.aggregator"
            :save="save"
            :edit="edit"
            :numOfGames="this.filteredGames.length"
            :selectedFilter="this.filter"
            :loading="this.loading"
            @change-filter="changeFilter"
            @toggle-parametr="toggleParametr"
            @delete-filter="deleteFilter"
        />
        <pagination
            :isChangeblePageSize="true"
            @change="showGames();"
            ref="pagination"
        />
    </div>
</template>
<script>
import gameService from '../../../../services/game.service';
import betconstructService from '../../../../services/betconstruct.service';

import pagination from '../../../common/pagination.vue';
import gameList from '../../../common/aggregator-games-list.vue';
import itemList from '../../../common/item-list.vue';

export default {
    name: "client-games-aggregator",
    components: {pagination, gameList, itemList},
    data() {
        return {
            searchProvider: '',
            searchCategory: '',
            providers: [],
            categoriesByProviders: {},
            categories: [],
            games: [],
            loading: false,
            timer: null,
            filter: {
                pageNumber: 1,
                search: '',
                provider: '',
                category: '',
                param: null,
                innerFilter: 'all'
            }
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        },
        aggregator() {
            return this.$route.params.aggregator;
        },
        providersByName() {
            return this.providers.filter(item => item === this.filter.provider || item.toLowerCase().indexOf(this.searchProvider.toLowerCase()) !== -1);
        },
        categoriesByName() {
            return this.categories.filter(item => item === this.filter.category || item.toLowerCase().indexOf(this.searchCategory.toLowerCase()) !== -1);
        },
        pageSize(){
            return this.$refs.pagination.itemsPerPage;
        },
        maxPage() {
            return Math.ceil(this.filteredGames.length/this.pageSize);
        },
        filteredGames() {
            let games = this.filter.innerFilter === 'all' 
            ? this.games
            : this.filter.innerFilter === 'new'
            ? this.games.filter(game => game.isNew)
            : this.games.filter(game => game.isPopular);

            return games.filter(game => {
                return (game.name.toLowerCase().indexOf(this.filter.search.toLowerCase()) !== -1) &&
                (!this.filter.provider || game.gameSourceProvider === this.filter.provider) &&
                (!this.filter.category || game.category === this.filter.category);
            });
        }
    },
    watch: {
        async clientId() {
            await this.getAllGames();
        }
    },
    async mounted() {
        await this.getAllGames();
        this.getProviders();
    },
    methods: {
        searchHandler(event){
            clearTimeout(this.timer);
            this.timer = setTimeout(()=>{this.filter.search = event.target.value; this.showGames()}, 500);
        },
        deleteFilter(option){
            this.filter[option] = '';
            if(option == 'provider'){
                this.getProviders();
            }
            this.showGames();
        },
        async toggleParametr(isEnable, param){
            this.loading = true;
            this.filter.param = param;
            const confirm  = window.confirm(`Are your sure you want to ${isEnable ? "Enable" : "Disable"} selected parameter for  selected games?`);
            if(confirm) {
                await betconstructService.changeParamForSelectedGames(this.clientId, this.filter, isEnable, this.getAllGames);
            }
            this.loading = false;
        },
        changeFilter(filter){
            this.filter.innerFilter = filter;
            this.showGames();
        },
        selectProvider(name) {
            if(!this.categoriesByProviders[name].includes(this.filter.category)) this.filter.category = '';

            if(this.filter.provider === name){
                this.filter.provider = '';
                this.getProviders();
            } else {
                this.filter.provider = name;
                this.providers.splice(this.providers.indexOf(name),1);
                this.providers.unshift(name);
                this.categories = this.categoriesByProviders[name];
            }

            if(this.$route.query.page != 1){
                this.$router.replace({'query':{'page':1}});
            };
            this.showGames();
        },
        selectCategory(name) {
            if(this.filter.category === name){
                this.filter.category = '';
            } else {
                this.filter.category = name;
                this.categories.splice(this.categories.indexOf(name),1);
                this.categories.unshift(name);
            }

            this.searchCategory = '';
            if(this.$route.query.page != 1){
                this.$router.replace({'query':{'page':1}});
            };
            this.showGames();
        },
        getProviders(){
            const data = betconstructService.getProviders(this.games);
            this.categoriesByProviders = data.providers;
            this.providers = Object.keys(data.providers);
            this.categories = data.categories;
        },
        async getAllGames() {
            this.loading = true;
            const games = await gameService.getClientGames(this.clientId, this.aggregator);
            this.games = games.sort((a,b) => {
                if(a.isEnabled !== b.isEnabled){
                    return b.isEnabled - a.isEnabled;
                }
                if(a.priority !== b.priority){
                    return b.priority - a.priority;
                }
                return 0;
            });
            this.showGames();
            this.loading = false;
        },
        showGames(){
            this.filter.pageNumber = this.$refs.pagination.pageNumber;
            if(this.$route.query.page > 0 && this.filter.pageNumber > this.maxPage) {
                this.filter.pageNumber = this.maxPage;
                this.$router.replace({ 'query': {'page':this.filter.pageNumber, size: this.pageSize}});
            };
            let gamesToShow = this.filteredGames.slice(this.pageSize*(this.filter.pageNumber-1), this.filter.pageNumber*this.pageSize);
            this.$refs.gamelist.set(gamesToShow, this.maxPage);
            this.$refs.pagination.set(this.$refs.pagination.pageNumber, this.maxPage);
        },
        async sync(){
            await gameService.syncProviderGamesForClientAsync(this.clientId, this.aggregator);
            await this.getAllGames();
        },
        async save(game) {
            await gameService.saveClientGame(game, this.clientId);
            await this.getAllGames();
        },
        async edit(game) {
            await gameService.saveGameProperties(game);
            await this.getAllGames();
        }
    }
}
</script>
<style scoped lang="scss">
.aggregator{
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.column.is-2 .field .control:first-child{
  flex-grow: 1;
}

.select.is-small{
    height: 100% !important;
}
</style>


// WEBPACK FOOTER //
// front/src/components/clients/client/games/aggregator.vue